import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenurightsService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }
  GetMenu(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamMgtApi/GetMenuList/');
  }
  GetAction()
    : Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/TeamMgtApi/GetActionList/');
  }
 
}
